import React from 'react';
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import useSWR, { SWRConfig } from 'swr'
import axios from "axios";
import Script from 'next/script'

import {ThemeProvider} from '@material-ui/core'
import PropTypes from 'prop-types';
import Head from 'next/head';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useStore } from '../stores/store'
import { Provider } from 'react-redux'
import MainLayout from '~/components/layout/mainLayout'
import SweetsCollectionLayout from '~/components/layout/sweetsCollectionLayout'
import OsechiLayout from '~/components/layout/osechiLayout'
import '../styles/globals.css'
import theme from'../styles/theme/muiTheme.js'

const fetcher = url => axios.get(url).then(res => res.data);
const fetcherWithParams = (url, params) => axios.get(url, {params: params}).then(res => res.data);

const App = ({ Component, pageProps }) => {
  const store = useStore(pageProps.initialReduxState)
  const persistor = persistStore(store, {}, function () {
    persistor.persist()
  })

  React.useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={<div>loading</div>} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <SWRConfig
            value={{
              fetcher: fetcher,
              revalidateIfStale: false,
              revalidateOnFocus: false,
              revalidateOnReconnect: false,
            }}
          >
            <React.Fragment>
              <Head>
                <title>ミールタイム</title>
                <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
                {
                  process.env.NEXT_PUBLIC_ALLOW_CRAWLING === 'false' &&
                  <>
                    <meta name="robots" content="none" />
                    <meta name="googlebot" content="none" />
                  </>
                }
                <meta name="keywords" content="糖尿病,脂質異常症,高血圧,痛風,腎臓病,透析,宅配,翌日配達" />
                <link rel="icon" href="/images/common/favicon.ico" />
              </Head>
              {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
              <CssBaseline />
              {
                pageProps.layout?.name === 'sweets-collection' &&
                  <SweetsCollectionLayout>
                    <Component {...pageProps} />
                  </SweetsCollectionLayout>
                ||
                pageProps.layout?.name === 'osechi' &&
                  <OsechiLayout>
                    <Component {...pageProps} />
                  </OsechiLayout>
                ||
                  <MainLayout layout={pageProps.layout}>
                    <Component {...pageProps} />
                  </MainLayout>
              }
            </React.Fragment>
          </SWRConfig>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

App.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
};

export default App

// ・metaタグが表示されなくなる件(状況によってPersistGateの記述箇所を変更する)
// https://qiita.com/HelloRusk/items/ca63e05772a3853b2a5d
// https://qiita.com/miyabiya/items/14e4f133d5df5d53cd77
// 子コンポーネントに、headタグを書く際は、<PersistGate loading={<div>loading</div>} persistor={persistor}>を
// 子コンポーネントに書く様に変更する。
